import React, { useCallback } from 'react';
import { Button, Icon } from '@servicetitan/anvil2';
import MicIcon from '@servicetitan/anvil2/assets/icons/material/round/mic.svg';
import BrowserModule from '@modules/BrowserModule';
import { audioDeviceStrings } from '../audioDeviceStrings';
import styles from './AudioDevicePanel.module.css';

interface AllowMicrophoneButtonProps {
  onClose?: () => void;
}

export const AllowMicrophoneButton: React.FC<AllowMicrophoneButtonProps> = ({
  onClose,
}) => {
  const handleClick = useCallback(() => {
    onClose?.();
    BrowserModule.requestMicrophoneAccess();
  }, [onClose]);

  return (
    <Button
      appearance='primary'
      onClick={handleClick}
      data-testid='audio-device-panel-allow-microphone'
      className={styles.testButton}
    >
      <Icon svg={MicIcon} size='medium' color='currentColor' />
      {audioDeviceStrings.testButtons.allowMicrophone}
    </Button>
  );
};
